export default "__VITE_ASSET__Y6ZpzdN4__"